import React from "react";
import { Col, Row, Card, CardBody, Collapse } from "reactstrap";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
const AuditCard = ({
  title = "Audit",
  auditData,
  isAccordionOpen = true,
  setIsAccordionOpen = () => {},
}) => {
  // Fonction pour basculer l'état du collapse
  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  // Convertir l'objet en tableau d'entrées
  const dataEntries = Object.entries(auditData);

  // Grouper les entrées par paires pour affichage 2 par 2
  const groupedEntries = [];
  for (let i = 0; i < dataEntries.length; i += 2) {
    groupedEntries.push(dataEntries.slice(i, i + 2));
  }
  function sanitizeSelector(str) {
    let sanitized = str.replace(/[^a-zA-Z0-9_-]/g, "_");
    if (/^\d/.test(sanitized)) {
      sanitized = "_" + sanitized;
    }
    return sanitized;
  }

  // SVG Icons inline
  const UserIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );

  const LinkIcon = ({ size = 12 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  );

  const InfoIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <circle cx="12" cy="12" r="10" />
      <path fill="#fff" d="M11 11h2v6h-2zm0-4h2v2h-2z" />
    </svg>
  );
  return (
    <Card
      className="shadow-sm border-0 overflow-hidden"
      style={{ borderRadius: "12px" }}
    >
      {/* En-tête cliquable */}
      <div
        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
        style={{
          background: "#555B21",
          letterSpacing: "0.5px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={toggleAccordion}
      >
        <div className="d-flex align-items-center">
          <span style={{ fontSize: "0.82rem" }}>{title}</span>
        </div>
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
          {isAccordionOpen ? (
            <FiChevronUp size={16} />
          ) : (
            <FiChevronDown size={16} />
          )}
        </span>
      </div>

      {/* Contenu repliable */}
      <Collapse isOpen={isAccordionOpen}>
        <CardBody className="p-0">
          <div className="fields-container" style={{ paddingBottom: "8px" }}>
            {groupedEntries.map((group, groupIndex) => (
              <Row key={groupIndex} className="g-0">
                {group.map(([key, value], itemIndex) => (
                  <Col
                    key={itemIndex}
                    xs={12}
                    lg={6}
                    className="field-item px-2 py-1"
                    style={{
                      backgroundColor: "white",
                      transition: "all 0.15s ease",
                      borderLeft: "3px solid transparent",
                      position: "relative",
                      cursor: "default",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#e3f2fd";
                      e.currentTarget.style.borderLeftColor = "#007bff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.style.borderLeftColor = "transparent";
                    }}
                  >
                    {/* Ligne de séparation subtile */}
                    {(groupIndex > 0 || itemIndex > 0) && (
                      <div
                        className="field-separator"
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          right: 0,
                          height: "1px",
                          background:
                            "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                        }}
                      />
                    )}

                    <Row className="align-items-center g-1">
                      <Col xs={12} md={5} className="field-label">
                        <div className="d-flex align-items-center small text-muted">
                          <span
                            className="fw-medium position-relative"
                            style={{
                              fontSize: "0.75rem",
                              letterSpacing: "0.2px",
                            }}
                          >
                            {key}
                          </span>
                          <span className="ms-1 text-primary">:</span>
                        </div>
                      </Col>

                      <Col xs={12} md={7} className="field-value">
                        <div
                          style={{
                            fontSize: "0.75rem",
                            padding: "3px 6px",
                            borderRadius: "6px",
                            backgroundColor: "#fff",
                            transition: "all 0.2s ease",
                            minHeight: "26px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {renderAuditValue(key, value)}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                ))}
              </Row>
            ))}
          </div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

const renderAuditValue = (key, value) => {
  // Valeur null ou undefined
  if (!value && value !== 0)
    return <span className="text-muted fst-italic">—</span>;

  // Formatage des statuts avec badges
  const statusBadges = {
    4: {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
      label: "Complété",
    },
    3: {
      bg: "linear-gradient(135deg, #17a2b8, #6f42c1)",
      color: "white",
      label: "En cours",
    },
    2: {
      bg: "linear-gradient(135deg, #ffc107, #fd7e14)",
      color: "white",
      label: "En attente",
    },
    1: {
      bg: "linear-gradient(135deg, #dc3545, #fd7e14)",
      color: "white",
      label: "Rejeté",
    },
  };

  // Si c'est un statut de requête
  if (key === "Statut de la requête" && statusBadges[value]) {
    const style = statusBadges[value];
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: style.bg,
          color: style.color,
          fontSize: "0.6rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {style.label}
      </span>
    );
  }

  // Valeurs booléennes
  if (value === true)
    return (
      <span
        className="text-success fw-semibold"
        style={{ fontSize: "0.75rem" }}
      >
        ✓
      </span>
    );
  if (value === false)
    return (
      <span className="text-danger fw-semibold" style={{ fontSize: "0.75rem" }}>
        ✗
      </span>
    );

  // Valeur par défaut
  return (
    <span className="text-dark" style={{ fontSize: "0.75rem" }}>
      {value}
    </span>
  );
};

export default AuditCard;
